<template>
  <ButtonBase :text="text" class="btn--primary" @click-button="onClick" />
</template>

<script>
import ButtonBase from '../../atoms/buttons/ButtonBase.vue'
export default {
  components: { ButtonBase },
  props: {
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick() {
      this.$emit('click-primary-button')
    }
  }
}
</script>

<style lang="scss" scoped>
.btn--primary {
  background-color: $primary;
  color: $white;

  a {
    color: $white;
  }
}
</style>
